var $ = jQuery;

$(document).ready(function () {
	if ($(window).width() > 765) {
		$("input[id='search-home']").attr(
			'placeholder',
			'Search slots, providers and casinos'
		);
	} else {
		$("input[id='search-home']").attr('placeholder', 'Search');
	}

	$('a[href*="#"]').on('click', function (event) {
		var href = $(this).attr('href').split('#')[1];
		var element = $('#' + href);

		if (!element.length) {
			return;
		}

		event.preventDefault();

		$('html, body').animate(
			{
				scrollTop: element.offset().top,
			},
			400
		);
	});

	$('.os-faq__item p:has(img.alignleft)').addClass('alignleft');
	$('.os-faq__item p:has(img.alignright)').addClass('alignright');
	$('.fa-angle-up').click(function (e) {
		e.preventDefault();
		$('.os-casino-single-header__terms').toggleClass('opened');
	});

	$('.close').click(function (e) {
		e.preventDefault();
		$('.os-casino-single-header__terms').toggleClass('opened');
	});

	$('.links_mobile_btn').click(function (e) {
		$('.links-sidebar-wrapper').toggleClass('opened');
	});

	$('.links-sidebar a').click(function (e) {
		$('.links-sidebar-wrapper').toggleClass('opened');
	});

	$('.os-casino-single-header__terms .close').click(function (e) {
		$(this).toggleClass('opened');
	});

	$(window).scroll(function () {
		if ($('.slot-main').length) {
			var containerof = document.querySelector(
				'.recommended-casinos__wrapper'
			);

			if (!containerof || !containerof.length) {
				return;
			}

			if (getOffset(containerof) <= 400) {
				$('.recommended-casinos__element').each(function () {
					$(this).addClass('flip');
				});
			} else {
				$('.recommended-casinos__element').each(function () {
					$(this).removeClass('flip');
				});
			}
			if (getOffset(containerof) <= -105) {
				$('.recommended-casinos__element').each(function () {
					$(this).removeClass('flip');
				});
			}
		}
	});

	var items = document.querySelectorAll('.accordion a');

	function toggleAccordion() {
		this.classList.toggle('active');
		this.nextElementSibling.classList.toggle('active');
	}

	items.forEach(function (item) {
		item.addEventListener('click', toggleAccordion);
	});

	function getOffset(el) {
		var rect = el.getBoundingClientRect();
		return rect.top;
	}

	$('.close-icon').click(function (e) {
		$('.popup-wrapper').toggleClass('hidden');
	});

	$('.providers-filter__menu').click(function (e) {
		e.preventDefault();
		$('.providers-filter__dropdown').toggleClass('visible');
		$(this).toggleClass('active');
	});

	$('#leadSlider').slick({
		dots: true,
		autoplay: true,
		autoplaySpeed: 10000,
	});

	$('#recommendedSlick').slick({
		dots: false,
		prevArrow:
			' <button><svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" viewBox="0 -256 1792 1792" id="svg3001" version="1.1" inkscape:version="0.48.3.1 r9886" width="100%" height="100%" sodipodi:docname="angle_left_font_awesome.svg"> <g transform="matrix(1,0,0,-1,516.33898,1194.3051)" id="g3003"> <path d="m 627,992 q 0,-13 -10,-23 L 224,576 617,183 q 10,-10 10,-23 0,-13 -10,-23 L 567,87 Q 557,77 544,77 531,77 521,87 L 55,553 q -10,10 -10,23 0,13 10,23 l 466,466 q 10,10 23,10 13,0 23,-10 l 50,-50 q 10,-10 10,-23 z" id="path3005" inkscape:connector-curvature="0" style="fill:currentColor"/> </g></svg></button>',
		nextArrow:
			' <button class="next"><svg xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:cc="http://creativecommons.org/ns#" xmlns:rdf="http://www.w3.org/1999/02/22-rdf-syntax-ns#" xmlns:svg="http://www.w3.org/2000/svg" xmlns="http://www.w3.org/2000/svg" xmlns:sodipodi="http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd" xmlns:inkscape="http://www.inkscape.org/namespaces/inkscape" viewBox="0 -256 1792 1792" id="svg3001" version="1.1" inkscape:version="0.48.3.1 r9886" width="100%" height="100%" sodipodi:docname="angle_left_font_awesome.svg"> <g transform="matrix(1,0,0,-1,516.33898,1194.3051)" id="g3003"> <path d="m 627,992 q 0,-13 -10,-23 L 224,576 617,183 q 10,-10 10,-23 0,-13 -10,-23 L 567,87 Q 557,77 544,77 531,77 521,87 L 55,553 q -10,10 -10,23 0,13 10,23 l 466,466 q 10,10 23,10 13,0 23,-10 l 50,-50 q 10,-10 10,-23 z" id="path3005" inkscape:connector-curvature="0" style="fill:currentColor"/> </g></svg></button>',
	});

	$('.mobile-hide').click(function () {
		$('.sidebar-hide').toggleClass('visible');
	});

	$(document).ready(function () {
		$('.hamburger').click(function () {
			$(this).toggleClass('is-active');
			$('.menu-wrapper').toggleClass('is-active');
			$('body').toggleClass('menu-is-active');
		});
	});

	// We also want to hide the menu when we click outside of it. Anywhere on the page.
	$(document).on('click', function (event) {
		if (!$('.hamburger').hasClass('is-active')) {
			return;
		}

		var clickedElement = $(event.target);

		// Check if we are inside the menu.
		var closest = clickedElement.closest('#header');

		if (closest.length) {
			return;
		}

		$('.hamburger').removeClass('is-active');
		$('.menu-wrapper').removeClass('is-active');
		$('body').removeClass('menu-is-active');
	});

	$('.search button').on('click', function (e) {
		// Only do this on desktop.
		if (window.innerWidth < 992) {
			return;
		}

		// We want to check, if the form is present. If not, show it and allow execution afterwards.
		var form = $(this).parent();

		if (!form.hasClass('is-expanded')) {
			e.preventDefault();
			form.addClass('is-expanded');
			form.find('[name="s"]').trigger('focus');
		}

		// e.preventDefault();
		// $(".search > .toggle > i ").toggleClass("fa fa-search");
		// $(".search > .toggle > i ").toggleClass("fas fa-angle-down");
		// $(".search > form").toggleClass("active");
	});

	$('.page-header > .container > .content > p > span').click(function (e) {
		e.preventDefault();
		$(this).toggleClass('active');
		$('.page-header > .container > .content > p:nth-of-type(n + 3)').toggle(
			300
		);
	});

	var country = false;
	var xTime;
	var validatedUser = getCookiesBS('validatedUser')
		? getCookiesBS('validatedUser')
		: 'false';

	$('.hero__embed').on('click', 'a.iframe-play-btn', function (e) {
		e.preventDefault();

		var heroEmbed = $(this).parents('.hero__embed');
		var id = heroEmbed.data('postid');
		var src = heroEmbed.data('src');

		$.ajax({
			type: 'POST',
			url: ajaxurl,
			data: {
				action: 'getIframe',
				id: id,
				src,
			},
			dataType: 'json',
			success: function (respons) {
				setCoookieTrue();
				heroEmbed.empty();
				heroEmbed.addClass('hero__embed--game-loaded');
				heroEmbed.append(respons.data.content);
			},
		});
	});

	var ageCheckJavaScriptLoaded = false;
	$('.hero__embed').on('click', 'a.age-gate-submit', function (e) {
		e.preventDefault();

		if (ageCheckJavaScriptLoaded) {
			showAgeCheckedPopup();
			return;
		}

		var script = document.createElement('script');
		script.src =
			'https://api.agechecked.com/api/jsapi/getjavascript?merchantkey=MKQjghdiWTLXzbxO0aeOdyrIMF5ZtE8UHZaSwMcwsd40NvoXj7%2bAKrow4oLWoJzY&version=1.0';
		script.type = 'text/javascript';
		script.onload = showAgeCheckedPopup;
		
		document.body.appendChild(script);
		ageCheckJavaScriptLoaded = true;
	});

	function showAgeCheckedPopup() {
		Agechecked.API.registerreturn(handlereturn);
		Agechecked.API.createagecheckjson({
			mode: 'javascript',
			avtype: 'agechecked',
			// source: "manual",
		}).done(function (json) {
			Agechecked.API.modalopen(json.agecheckurl);
		});
	}

	function handlereturn(d) {
		var msg = JSON.parse(d.data);

		if (msg.status == 6 || msg.status == 7 || msg.status == 12) {
			setCoookieTrue();
		}

		if (typeof msg.modalclose !== 'undefined' && msg.modalclose === true) {
			Agechecked.API.modalclose();

			var validatedUser = getCookiesBS('validatedUser')
				? getCookiesBS('validatedUser')
				: 'false';
			var postId = $('.hero__embed').data('postid');

			$.ajax({
				type: 'POST',
				url: ajaxurl,
				data: {
					action: 'gamewrapper',
					country: country,
					validatedUser: validatedUser,
					postid: postId,
				},
				success: function (response) {
					$('.hero__embed').empty();
					$('.hero__embed').append(response.data.content);

					if (validatedUser) {
						$('.hero__embed').addClass('hero__embed--game-loaded');
					}

					$('html, body').animate(
						{
							scrollTop: $('.slot-review-demo-section').offset()
								.top,
						},
						400
					);
				},
			});
		}
	}

	$('.hero__embed').on('click', 'a.verify', function (e) {
		e.preventDefault();

		var vm = $(this);
		var heroEmbed = $(this).parents('.hero__embed');
		var inputVal = heroEmbed.find('#phone').val();
		var numericReg =
			/^(?:(?:\(?(?:0(?:0|11)\)?[\s-]?\(?|\+)44\)?[\s-]?(?:\(?0\)?[\s-]?)?)|(?:\(?0))(?:(?:\d{5}\)?[\s-]?\d{4,5})|(?:\d{4}\)?[\s-]?(?:\d{5}|\d{3}[\s-]?\d{3}))|(?:\d{3}\)?[\s-]?\d{3}[\s-]?\d{3,4})|(?:\d{2}\)?[\s-]?\d{4}[\s-]?\d{4}))(?:[\s-]?(?:x|ext\.?|\#)\d{3,4})?$/;

		if (!numericReg.test(inputVal)) {
			console.log('error');
		} else {
			vm.html('Loading');
			$('#phone').remove();
			$('.os-age-gate-wrapper__verify-box-title').html(
				'Please text VERIFY to 89188 in order for us to Age-Verify you.'
			);
			$('.os-age-gate-wrapper__verify-box-text').html(
				'Or Reply with VERIFY to the SMS we have just sent.'
			);
			$('.os-age-gate-wrapper__verify-box-below-buttons')
				.html(
					'SMS text messages are charged at the standard network rate'
				)
				.addClass(
					'os-age-gate-wrapper__verify-box-below-buttons--sms-pay-hint'
				);
			xTime = setTimeout(poll, 5000, inputVal);
		}
	});

	$('.hero__embed').on('click', 'a.cancel', function (e) {
		e.preventDefault();

		var validatedUser = getCookiesBS('validatedUser')
			? getCookiesBS('validatedUser')
			: 'false';
		var postId = $('.hero__embed').data('postid');

		$.ajax({
			type: 'POST',
			url: ajaxurl,
			data: {
				action: 'gamewrapper',
				country: country,
				validatedUser: validatedUser,
				postid: postId,
			},
			success: function (response) {
				$('.hero__embed').empty();
				$('.hero__embed').append(response.data.content);
			},
		});
	});

	function setCoookieTrue() {
		var date = new Date();
		date.setMonth(date.getMonth() + 1);
		document.cookie = 'validatedUser=true;expires=' + date + ';path=/';
		console.log('success cookie', date);
	}

	function poll(number) {
		$.ajax({
			type: 'POST',
			url: ajaxurl,
			data: {
				action: 'phoneValidator',
				number: number,
			},
			dataType: 'json',
			success: function (response) {
				var data = JSON.parse(response.data);

				if (data.transaction && data.transaction.av == 'TRUE') {
					clearTimeout(xTime);
					$.ajax({
						type: 'POST',
						url: ajaxurl,
						data: {
							action: 'getPlayButtonIframe',
							id: $('.hero__embed').data('postid'),
						},
						dataType: 'json',
						success: function (respons) {
							setCoookieTrue();
							$('.hero__embed').empty();
							$('.hero__embed').append(respons.data.content);
						},
					});
				} else if (data.transaction && data.transaction.av == 'FALSE') {
					var value =
						'Sorry. We were unable to Age-Verify you via your mobile account ' +
						number +
						'.<br>Please contact your Mobile Operator and ask to be Adult-Verified & then try again.';
					$('h2.verime__title').html(value);
					$('a.verify').remove();
					$('a.cancel').html('Try again');
				} else {
					xTime = setTimeout(poll, 5000, number);
				}
			},
		});
	}

	function iPApiCall() {
		$.ajax(
			{
				type: 'GET',
				url: 'https://ipapi.co/json/',
				success: function (response) {
					country = response.country;
					initGameWrapper(country);
				},
			},
			'jsonp'
		);
	}

	function cloudFlareApiCall() {
		if ((country = sessionStorage.getItem('cf-country'))) {
			initGameWrapper(country);
			return;
		}

		$.ajax({
			type: 'GET',
			url: 'https://www.online-slot.co.uk/cdn-cgi/trace',
			success: function (response) {
				var responseArray = response.split('\n');
				var cfCountry = false;

				$.each(responseArray, function (index, element) {
					var array = element.split('=');

					if (array[0] != 'loc') {
						return;
					}

					cfCountry = array[1];
					return false;
				});

				if (!cfCountry) {
					iPApiCall();
					return;
				}

				country = cfCountry;
				sessionStorage.setItem('cf-country', cfCountry);
				initGameWrapper(country);
			},
			error: function () {
				iPApiCall();
			},
		});
	}

	$('.hero__embed').on('click', '.load-demo-btn', cloudFlareApiCall);
	$('.hero__embed').on('click', '.show-bonus-btn', showBonusOnDemoOverlay);

	function showBonusOnDemoOverlay() {
		// Add classes.
		$(this).parents('.buttons').addClass('bonus-active');
	}

	$('.hero__embed').on('click', '.close-bonus', closeBonusOnDemoOverlay);

	function closeBonusOnDemoOverlay() {
		$(this).parents('.buttons').removeClass('bonus-active');
	}

	$('.game-container').on('click', '.game-container__bonus-wrap .close-bonus', function () {
		// We just completely remove the html for this.
		$('.game-container__bonus-wrap').remove();
	});

	function initGameWrapper(country) {
		var heroEmbed = $('.hero__embed');
		var postId = heroEmbed.data('postid');
		var seconds = heroEmbed.data('seconds');

		$.ajax({
			type: 'POST',
			url: ajaxurl,
			data: {
				action: 'gamewrapper',
				country: country,
				validatedUser: validatedUser,
				postid: postId,
			},
			success: function (response) {
				$('.hero__embed').html(response.data.content);

				if (response.data.gameLoaded) {
					$('.hero__embed').addClass('hero__embed--game-loaded');

					if (seconds) {
						// Set timeout.
						setTimeout(function () {
							// Show bonus.
							$('.game-container').addClass('bonus-active');
						}, seconds * 1000);
					}

				}
			},
		});
	}

	window.getCookie = function (name) {
		var match = document.cookie.match(
			new RegExp('(^| )' + name + '=([^;]+)')
		);
		if (match) return match[2];
	};

	function getCookiesBS(name) {
		var match = document.cookie.match(
			new RegExp('(^| )' + name + '=([^;]+)')
		);
		return match ? match[2] : undefined;
	}

	var $content = $('#slotswrapper');
	var $loader = $('#moreposts');
	var ppp = 20;
	var offset = $('#slotswrapper').find('article').length;
	var postid = $('[data-postid]').data('postid');
	$loader.click(function load_ajax_posts(e) {
		e.preventDefault();
		var hidden = $(this).data('hidden');
		if (
			!(
				$loader.hasClass('post_loading_loader') ||
				$loader.hasClass('post_no_more_posts')
			)
		) {
			$.ajax({
				type: 'POST',
				dataType: 'html',
				url: ajaxurl,
				data: {
					ppp: ppp,
					offset: offset,
					action: hidden
						? 'casino_more_hidden_post_ajax'
						: 'casino_more_post_ajax',
					postid: postid,
				},
				beforeSend: function () {
					$loader.addClass('post_loading_loader').html('Verifying');
				},
				success: function (data) {
					var $data = $(data);
					if ($data.length) {
						var $newElements = $data.css({
							opacity: 0,
						});
						$content.append($newElements);
						$newElements.animate({
							opacity: 1,
						});
						$loader
							.removeClass('post_loading_loader')
							.html('Load More');
					} else {
						$loader.hide();
						$loader
							.removeClass('post_loading_loader')
							.addClass('post_no_more_posts')
							.html('No More Posts');
					}
					if ($data.length < 20) {
						$loader.hide();
						$loader
							.removeClass('post_loading_loader')
							.addClass('post_no_more_posts')
							.html('No More Posts');
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {
					$loader.html(
						$.parseJSON(jqXHR.responseText) +
							' :: ' +
							textStatus +
							' :: ' +
							errorThrown
					);
					console.log(jqXHR);
				},
			});
		}
		offset += ppp;
		return false;
	});

	var timeout;

	$(window).click(function () {
		if ($('.search-results').hasClass('search-results--active')) {
			$('.search-results').removeClass('search-results--active');
		}
		if ($('.os-search__results').hasClass('os-search__results--active')) {
			$('.os-search__results').removeClass('os-search__results--active');
		}
	});

	$('.os-search__input-wrapper input').on('keyup', function () {
		var searchQuery = $(this).val().toLowerCase();
		var searchForm = $('.os-search__results');
		$(this).click(function () {
			searchForm.toggleClass('os-search__results--active');
		});
		if (timeout) {
			clearTimeout(timeout);
		}
		if (searchQuery.split('').length < 1) {
			searchForm.removeClass('os-search__results--active');
			return;
		}
		timeout = setTimeout(function () {
			$.ajax({
				type: 'POST',
				dataType: 'html',
				url: ajaxurl,
				data: {
					action: 'casino_search_post_ajax',
					search: searchQuery,
					home_request: 'true',
				},
				success: function (data) {
					var $data = $(data);
					$('.os-search__results').addClass(
						'os-search__results--active'
					);
					if ($data.length) {
						var $newElements = $data.css({
							opacity: 0,
						});
						searchForm.html($newElements);
						$newElements.animate({
							opacity: 1,
						});
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {
					$loader.html(
						$.parseJSON(jqXHR.responseText) +
							' :: ' +
							textStatus +
							' :: ' +
							errorThrown
					);
				},
			});
		}, 500);
	});

	$('.providers-filter__mobile').click(function () {
		$('.providers-filter__wrapper').toggleClass('visible');
		$(this).toggleClass('clicked');
	});

	$('.search-box').on('keyup', function () {
		var searchQuery = $(this).val().toLowerCase();
		var searchForm = $('.search-results');
		if (searchQuery.length > 0) {
			$('.providers-filter__search-wrapper').addClass('fixed');
		} else {
			$('.providers-filter__search-wrapper').removeClass('fixed');
		}
		$(this).click(function () {
			$('.search-results').removeClass('search-results--active');
		});
		if (timeout) {
			clearTimeout(timeout);
		}
		timeout = setTimeout(function () {
			$.ajax({
				type: 'POST',
				dataType: 'html',
				url: ajaxurl,
				data: {
					action: 'casino_search_post_ajax',
					search: searchQuery,
				},
				beforeSend: function () {
					console.log('before send');
				},
				success: function (data) {
					var $data = $(data);
					$('.search-results').addClass('search-results--active');
					if ($data.length) {
						var $newElements = $data.css({
							opacity: 0,
						});
						searchForm.html($newElements);
						$newElements.animate({
							opacity: 1,
						});
					} else {
						//    $loader.hide();
						//    $loader.removeClass('post_loading_loader').addClass('post_no_more_posts').html('No More Posts');
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {
					$loader.html(
						$.parseJSON(jqXHR.responseText) +
							' :: ' +
							textStatus +
							' :: ' +
							errorThrown
					);
					console.log(jqXHR);
				},
			});
		}, 500);
	});

	$('.casino__details-toggle').on('click', function () {
		$(this).toggleClass('casino__details-toggle--is-active');
		$(this)
			.parent()
			.next()
			.slideToggle({
				start: function () {
					$(this).css({
						display: 'grid',
					});
				},
			});
	});

	$('.os-tooltip__toggle').on('click', function () {
		$('body').addClass('body--is-locked');
		$(this).next().show();
		bodyScrollLock.disableBodyScroll($(this)[0]);
	});

	$(document).on('click', function (event) {
		if (!$(event.target).closest('.os-tooltip').length) {
			$('.os-tooltip__content').hide();
			$('body').removeClass('body--is-locked');
			bodyScrollLock.clearAllBodyScrollLocks();
		}
	});
});
